import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { ASSET_PREFIX } from 'utils/constants';
import Link from 'next/link';

const WinnerContentSection = ({ onCtaClick }) => (
  <PaddedMaxWidthContainer style={{ margin: '4em auto' }}>
    <Subheading>
      600,000+ Winners Of Prizes Big And <strong>Small</strong>
    </Subheading>

    <p>Will you be next?</p>

    <div className="quoteContainer">
      <Link
        href="https://www.trustpilot.com/review/daymade.co.uk"
        style={{ flex: 1 }}
      >
        <div className="quote">
          <div className="message">
            "Love being part of Daymade ... It's one of the few places you do
            actually win prizes!"
          </div>
          <div className="author">- Naomi W</div>
          <img
            src={`${ASSET_PREFIX}/images/landing/stronger-variant/trustpilot-5-stars.svg`}
            alt="5 stars on Trustpilot"
            className="trustpilotLogo"
          />
        </div>
      </Link>

      <Link
        href="https://www.trustpilot.com/review/daymade.co.uk"
        style={{ flex: 1 }}
      >
        <div className="quote">
          <div className="message">
            "Brilliant site and I'm glad that every entry means that a tree is
            planted!!"
          </div>
          <div className="author">- Ben T</div>
          <img
            src={`${ASSET_PREFIX}/images/landing/stronger-variant/trustpilot-5-stars.svg`}
            alt="5 stars on Trustpilot"
            className="trustpilotLogo"
          />
        </div>
      </Link>

      <Link
        href="https://www.trustpilot.com/review/daymade.co.uk"
        style={{ flex: 1 }}
      >
        <div className="quote">
          <div className="message">
            "I've won twice now! A £20 Amazon voucher and a Sushi making kit!!"
          </div>
          <div className="author">- Connor B</div>
          <img
            src={`${ASSET_PREFIX}/images/landing/stronger-variant/trustpilot-5-stars.svg`}
            alt="5 stars on Trustpilot"
            className="trustpilotLogo"
          />
        </div>
      </Link>
    </div>

    <RoundedButton onClick={onCtaClick} style={{ width: 220 }}>
      Enter Now
    </RoundedButton>

    <style jsx>
      {`
        .quoteContainer {
          display: flex;
          margin-bottom: 1.5em;
        }

        .quote {
          cursor: pointer;
          text-align: center;
          flex: 1;
          margin: 1em;
        }

        .message {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .author {
          font-style: italic;
          font-size: 1rem;
          font-weight: 600;
          margin: 0.6em 0;
        }

        .trustpilotLogo {
          width: 80px;
        }

        @media (max-width: 700px) {
          .quoteContainer {
            flex-direction: column;
          }
        }
      `}
    </style>
  </PaddedMaxWidthContainer>
);

export default WinnerContentSection;
